import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Hongkong() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Hongkong') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [carrier, setCarrier] = useState();
    const [name, setName] = useState();
    const [br, setBr] = useState();
    const [custAccNum, setCustAccNum] = useState();
    const [equipment, setEquipment] = useState();
    const [address, setAddress] = useState();
    const [flat, setFlat] = useState();
    const [floor, setFloor] = useState();
    const [block, setBlock] = useState();
    const [building, setBuilding] = useState();
    const [estate, setEstate] = useState();
    const [sNumber, setSNumber] = useState();
    const [sName, setSName] = useState();
    const [district, setDistrict] = useState();
    const [lotNumber, setLotNumber] = useState();
    const [area, setArea] = useState();
    const [cAddress, setCAddress] = useState();
    const [contact, setContact] = useState();
    const [tNumber, setTNumber] = useState();
    const [fNumber, setFNumber] = useState();
    const [isMainline, setIsMainline] = useState(false);

    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {

        document.querySelector('#carrier').value = form?.country?.carrier ?? '';
        setCarrier(form?.country?.carrier ?? '');

        document.querySelector('#name').value = form?.country?.name ?? '';
        setName(form?.country?.name ?? '');

        document.querySelector('#br').value = form?.country?.br ?? '';
        setBr(form?.country?.br ?? '');

        document.querySelector('#custAccNum').value = form?.country?.custAccNum ?? '';
        setCustAccNum(form?.country?.custAccNum ?? '');

        document.querySelector('#equipment').value = form?.country?.equipment ?? '';
        setEquipment(form?.country?.equipment ?? '');

        document.querySelector('#address').value = form?.country?.address ?? '';
        setAddress(form?.country?.address ?? '');

        document.querySelector('#flat').value = form?.country?.flat ?? '';
        setFlat(form?.country?.flat ?? '');

        document.querySelector('#floor').value = form?.country?.floor ?? '';
        setFloor(form?.country?.floor ?? '');

        document.querySelector('#block').value = form?.country?.block ?? '';
        setBlock(form?.country?.block ?? '');

        document.querySelector('#building').value = form?.country?.building ?? '';
        setBuilding(form?.country?.building ?? '');

        document.querySelector('#estate').value = form?.country?.estate ?? '';
        setEstate(form?.country?.estate ?? '');

        document.querySelector('#sNumber').value = form?.country?.sNumber ?? '';
        setSNumber(form?.country?.sNumber ?? '');

        document.querySelector('#sName').value = form?.country?.sName ?? '';
        setSName(form?.country?.sName ?? '');

        document.querySelector('#district').value = form?.country?.district ?? '';
        setDistrict(form?.country?.district ?? '');

        document.querySelector('#lotNumber').value = form?.country?.lotNumber ?? '';
        setLotNumber(form?.country?.lotNumber ?? '');

        document.querySelector('#area').value = form?.country?.area ?? '';
        setArea(form?.country?.area ?? '');

        document.querySelector('#cAddress').value = form?.country?.cAddress ?? '';
        setCAddress(form?.country?.cAddress ?? '');

        document.querySelector('#contact').value = form?.country?.contact ?? '';
        setContact(form?.country?.contact ?? '');

        document.querySelector('#tNumber').value = form?.country?.tNumber ?? '';
        setTNumber(form?.country?.tNumber ?? '');

        document.querySelector('#fNumber').value = form?.country?.fNumber ?? '';
        setFNumber(form?.country?.fNumber ?? '');

        document.querySelector('#mainline').checked = form?.country?.isMainline ?? false;
        setIsMainline(form?.country?.isMainline ?? false);


        // Table data arrays
        setTableDataSingle(form?.country?.table1 ?? []);
        //setTableData(form?.country?.table2 ?? []);
        setTableDataRange(form?.country?.Number_Range ?? []);

    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (first)--------------------------------------//

    const [tableDataSingle, setTableDataSingle] = useState([{ id: Date.now(), num: '' }]);

    //adding a row
    const addRow_single = () => {
        setTableDataSingle([...tableDataSingle, { id: Date.now(), num: '' }]);
    };

    //removing a row
    const removeRow_single = (id) => {
        setTableDataSingle(tableDataSingle.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableSingle = (id, key, value) => {
        const updatedData = tableDataSingle.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataSingle(updatedData);
    };

    //--------------------------------table declaration (second)--------------------------------------//

    const [tableDataRange, setTableDataRange] = useState([{ id: Date.now(), sNumber: '', eNumber: '' }]);

    //adding a row
    const addRow_range = () => {
        setTableDataRange([...tableDataRange, { id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    //removing a row
    const removeRow_range = (id) => {
        setTableDataRange(tableDataRange.filter(row => row.id !== id));
    };

    //change handler of table
    const handleChange_tableRange = (id, key, value) => {
        const updatedData = tableDataRange.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableDataRange(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data for tableDataRange
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            setTableDataRange(formattedDataRange);

            // Validate each row: must be numeric and not empty
            formattedDataRange.forEach(row => {
                const isStartValid = /^\d+$/.test(row.sNumber);
                const isEndValid = /^\d+$/.test(row.eNumber);

                setValidationStates(prev => ({
                    ...prev,
                    [`startNumber-${row.id}`]: isStartValid,
                    [`endNumber-${row.id}`]: isEndValid,
                }));
            });
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableDataRange([{ id: Date.now(), sNumber: '', eNumber: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Hongkong",

            "carrier": carrier,
            "name": name,
            "br": br,
            "custAccNum": custAccNum,
            "equipment": equipment,
            "address": address,
            "flat": flat,
            "floor": floor,
            "block": block,
            "building": building,
            "estate": estate,
            "sNumber": sNumber,
            "sName": sName,
            "district": district,
            "lotNumber": lotNumber,
            "area": area,
            "cAddress": cAddress,
            "contact": contact,
            "tNumber": tNumber,
            "fNumber": fNumber,
            "isMainline": isMainline,
            "table1": tableDataSingle,
            "Number_Range": tableDataRange

        },
        "email": sessionStorage.getItem('email'),
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {

        let validationErrors = {};

        if (!carrier) {
            validationErrors.carrier = 'please fill in Loser Carrier';
        }
        if (!name) {
            validationErrors.name = 'please fill in Customer Name as registered with #';
        }
        if (!br) {
            validationErrors.br = 'please fill in ID/BR/Passport No.';
        }
        if (!address) {
            validationErrors.address = 'please fill in Installation Address';
        }
        if (!contact) {
            validationErrors.contact = 'please fill in Customer Contact Person';
        }
        if (!tNumber) {
            validationErrors.tNumber = 'please fill in Tel Number';
        }
        tableDataRange.forEach(row => {
            const startId = `startNumber-${row.id}`;
            const endId = `endNumber-${row.id}`;

            // Validate start number
            if (!row.sNumber) {
                validationErrors[startId] = 'Please fill in the start of the number range.';
            } else if (!/^\d+$/.test(row.sNumber)) {
                validationErrors[startId] = 'Start number must be numeric.';
            }

            // Validate end number
            if (!row.eNumber) {
                validationErrors[endId] = 'Please fill in the end of the number range.';
            } else if (!/^\d+$/.test(row.eNumber)) {
                validationErrors[endId] = 'End number must be numeric.';
            }
        });

        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            //Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;

        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }
        // If all validations pass, proceed with the form submission
        e.preventDefault();
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = address + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p>

                    <h2 className='heading'>Part(A)</h2> <br></br>

                    <Row>
                        <Col>
                            <label>The Loser Carrier*</label> <br />
                            <input
                                onChange={(e) => setCarrier(e.target.value)}
                                type="text"
                                id="carrier"
                                placeholder=""
                                className={`inputbox ${validationStates.carrier === false ? 'error' : ''}`}
                                onBlur={() => validateInput('carrier', /^[\w\W,]+$/)}

                            />
                        </Col>
                    </Row>

                    <br></br>

                    <h4 className='heading'>Customer Information</h4> <br></br>

                    <Row>
                        <Col>
                            <label>Customer Name(as registered with #)*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id="name"
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col>
                            <label>ID/BR/Passport No.*</label> <br />
                            <input
                                onChange={(e) => setBr(e.target.value)}
                                type="text"
                                id="br"
                                placeholder=""
                                className={`inputbox ${validationStates.br === false ? 'error' : ''}`}
                                onBlur={() => validateInput('br', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col>
                            <label>Customer Account Number</label> <br />
                            <input
                                onChange={(e) => setCustAccNum(e.target.value)}
                                type="text"
                                id="custAccNum"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br><br></br>

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number(s) and/or services (features) requested for termination</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableDataSingle.map(row => (
                                <tr key={row.id}>
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_tableSingle(row.id, 'num', value);

                                                // Validate: allow only digits, dashes, and spaces
                                                if (value !== '' && !/^[\d\s-]+$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (row.num !== '' && !/^[\d\s-]+$/.test(row.num)) {
                                                    toast.error('Number must contain only digits, dashes, or spaces.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                all telephone / Private Circuit / Dataline numbers and/or services (features) involved have to be specified and please attach sheets in case of insufficient space) [ ]*** Duplex ringing number(s) to be terminated (if any) Duplex ringing number(s) (optional ):
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must contain only digits, dashes, or spaces.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataSingle.length > 1 && (
                                            <button onClick={() => removeRow_single(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow_single}>Add Row</button>


                    <br></br><br></br><br></br>

                    <Row>
                        <Col>
                            <label>Equipment supplied by</label> <br />
                            <select name="equipment" id="equipment" value={equipment} onChange={(e) => setEquipment(e.target.value)} className="inputbox">
                                <option value=""></option>
                                <option value="Nil">Nil</option>
                                <option value="continue to rent from #">continue to rent from #</option>
                                <option value="return to #">return to #</option>
                            </select>
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('address')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Installation Address*</label> <br />
                            <input
                                onChange={(e) => setAddress(e.target.value)}
                                type="text"
                                id="address"
                                placeholder=""
                                className={`inputbox ${validationStates.address === false ? 'error' : ''}`}
                                onBlur={() => validateInput('address', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'address' && (
                                <div className="hover-description">
                                    the company address as registered at the loser provider
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Flat/Room/Unit</label> <br />
                            <input
                                onChange={(e) => setFlat(e.target.value)}
                                type="text"
                                id="flat"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Floor</label> <br />
                            <input
                                onChange={(e) => setFloor(e.target.value)}
                                type="text"
                                id="floor"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <label>Block</label> <br />
                            <input
                                onChange={(e) => setBlock(e.target.value)}
                                type="text"
                                id="block"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Building</label> <br />
                            <input
                                onChange={(e) => setBuilding(e.target.value)}
                                type="text"
                                id="building"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Estate</label> <br />
                            <input
                                onChange={(e) => setEstate(e.target.value)}
                                type="text"
                                id="estate"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Street Number</label> <br />
                            <input
                                onChange={(e) => setSNumber(e.target.value)}
                                type="text"
                                id="sNumber"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col>
                            <label>Street Name</label> <br />
                            <input
                                onChange={(e) => setSName(e.target.value)}
                                type="text"
                                id="sName"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>District</label> <br />
                            <input
                                onChange={(e) => setDistrict(e.target.value)}
                                type="text"
                                id="district"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Lot Number</label> <br />
                            <input
                                onChange={(e) => setLotNumber(e.target.value)}
                                type="text"
                                id="lotNumber"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>

                        <Col>
                            <label>Area</label> <br />
                            <select name="area" id="area" value={area} onChange={(e) => setArea(e.target.value)} className="inputbox">
                                <option value=""></option>
                                <option value="HK (Hong Kong)">HK (Hong Kong)</option>
                                <option value="KL (Kowloon)">KL (Kowloon)</option>
                                <option value="NT ( New Territories)">NT ( New Territories)</option>
                            </select>
                        </Col>
                    </Row>

                    <br></br>

                    <Row>
                        <Col
                            onMouseEnter={() => handleMouseEnter('cAddress')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>New Correspondence Address</label> <br />
                            <input
                                onChange={(e) => setCAddress(e.target.value)}
                                type="text"
                                id="cAddress"
                                placeholder=""
                                className={`inputbox`}
                            />
                            {hoveredField === 'cAddress' && (
                                <div className="hover-description">
                                    required only if different from above
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('contact')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Contact Person*</label> <br />
                            <input
                                onChange={(e) => setContact(e.target.value)}
                                type="text"
                                id="contact"
                                placeholder=""
                                className={`inputbox ${validationStates.contact === false ? 'error' : ''}`}
                                onBlur={() => validateInput('contact', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'contact' && (
                                <div className="hover-description">
                                    the contact person and contact phone number at Hong Kong
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Tel Number*</label> <br />
                            <input
                                onChange={(e) => setTNumber(e.target.value)}
                                type="text"
                                id="tNumber"
                                placeholder=""
                                className={`inputbox ${validationStates.tNumber === false ? 'error' : ''}`}
                                onBlur={() => validateInput('tNumber', /^[\w\W,]+$/)}

                            />
                        </Col>

                        <Col>
                            <label>Fax Number</label> <br />
                            <input
                                onChange={(e) => setFNumber(e.target.value)}
                                type="text"
                                id="fNumber"
                                placeholder=""
                                className={`inputbox`}
                            />
                        </Col>
                    </Row>

                    <br></br><br></br>

                    <p>The Customer authorises # to terminate the number(s) and/or services (features) identified above (each a ìServiceî) and acknowledges and agrees that # excludes all liability to the Customer and any third party which may arise out of or in connection with termination of the Services whether in contract, tort, or otherwise and including direct loss and indirect loss (including loss of profit, goodwill or business opportunity or any other consequential loss or any cost relating to any interruption of the Customerís or any other partyís business) incurred by the Customer or any third party</p>

                    <br></br>

                    <h4 className='heading'>Termination of the associated duplex ringing number(s)</h4><br></br>

                    <Row>

                        <Col>
                            <div className="checkbox-container">
                                <input
                                    type="checkbox"
                                    id="mainline"
                                    name="mainline"
                                    checked={isMainline}
                                    onChange={(e) => setIsMainline(e.target.checked)}
                                />
                                <label htmlFor="mainline">
                                    The Customer authorises # to terminate the number(s) and the associated duplex ringing number(s) (the termination of which is requested above) and/or services (features) identified above (each a ìServiceî) and acknowledges and agrees that # excludes all liability to the Customer and any third party which may arise out of or in connection with termination of the Services whether in contract, tort, or otherwise and including direct loss and indirect loss (including loss of profit, goodwill or business opportunity or any other consequential loss or any cost relating to any interruption of the Customerís or any other partyís business) incurred by the Customer or any third party.
                                </label>
                            </div>
                        </Col>

                    </Row>

                </Container>

                <br></br>

                <Container>

                    <h2 className='heading'>Part(B)</h2> <br></br>

                    <h4 className='heading'>Numbers to be ported</h4><br></br>

                    <p>For single numbers add the same number in the two columns (Start and end).</p>

                    {/* <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Number(s) requested for Operator Number Portability</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map(row => (
                                <tr key={row.id}>
                                    <td
                                        onMouseEnter={() => handleMouseEnter(`number-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`number-${row.id}`}
                                            value={row.num}
                                            onChange={(e) => {
                                                const value = e.target.value;

                                                // Update the state with the input value
                                                handleChange_table(row.id, 'num', value);

                                                // Validate: allow only numeric digits
                                                if (value !== '' && !/^\d+$/.test(value)) {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                } else {
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: true,
                                                    }));
                                                }
                                            }}
                                            className={`inputbox ${validationStates[`number-${row.id}`] === false && row.num !== '' ? 'error' : ''}`}
                                            onBlur={() => {
                                                if (row.num !== '' && !/^\d+$/.test(row.num)) {
                                                    toast.error('Number must contain only digits.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`number-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `number-${row.id}` && (
                                            <div className="hover-description">
                                                the number(s) to be ported in HKBN (all telephone numbers involved and requested services have to be specified and please attach sheets in case of insufficient space)
                                            </div>
                                        )}
                                        {validationStates[`number-${row.id}`] === false && row.num !== '' && (
                                            <div className="error-message">
                                                Number must contain only digits.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button> */}

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>Telephone Numbers Range Start*</th>
                                <th>Telephone Numbers Range End*</th>
                            </tr>
                        </thead>

                        <tbody>

                            {tableDataRange.map(row => (
                                <tr key={row.id}>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`startNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`startNumber-${row.id}`}
                                            value={row.sNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'sNumber', value);

                                                const isValid = /^\d+$/.test(value); // Only numeric and not empty
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`startNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`startNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\d+$/.test(row.sNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input is allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`startNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `startNumber-${row.id}` && (
                                            <div className="hover-description">
                                                the number(s) to be ported in HKBN (all telephone numbers involved and requested services have to be specified and please attach sheets in case of insufficient space)
                                            </div>
                                        )}
                                        {validationStates[`startNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td
                                        onMouseEnter={() => handleMouseEnter(`endNumber-${row.id}`)}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <input
                                            type="text"
                                            id={`endNumber-${row.id}`}
                                            value={row.eNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_tableRange(row.id, 'eNumber', value);

                                                const isValid = /^\d+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`endNumber-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`endNumber-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\d+$/.test(row.eNumber);
                                                if (!isValid) {
                                                    toast.error('Only numeric input is allowed and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`endNumber-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {hoveredField === `endNumber-${row.id}` && (
                                            <div className="hover-description">
                                                the number(s) to be ported in HKBN (all telephone numbers involved and requested services have to be specified and please attach sheets in case of insufficient space)
                                            </div>
                                        )}
                                        {validationStates[`endNumber-${row.id}`] === false && (
                                            <div className="error-message">
                                                Only numeric input allowed and cannot be empty.
                                            </div>
                                        )}
                                    </td>

                                    <td>
                                        {tableDataRange.length > 1 && (
                                            <button onClick={() => removeRow_range(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </Table>

                    <button onClick={addRow_range}>Add Row</button>

                    <br></br><br></br>

                </Container>

                <br></br>

                <p className='heading'>Note:the signatory must be registered as authorisation person at the loser carrier</p>

                <br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Hongkong;